document.querySelectorAll( '.b-tabbed-content' ).forEach( ( block ) => {

	const tabsNav = block.querySelector( '.js-tabs-nav' );
	const buttons = block.querySelectorAll( '.tab-button' );
	const panels = block.querySelectorAll( '.tab-panel' );

	if ( !tabsNav || ! buttons.length || ! panels.length ) {

		return;

	}

	tabsNav.addEventListener( 'click', ( e ) => {

		const tab = e.target.closest( '.tab-button' );

		if ( !tab ) {

			return;

		}

		buttons.forEach( btn => {

			btn.classList.remove( 'is-active' );
			btn.setAttribute( 'aria-selected', 'false' );

		} );

		panels.forEach( panel => {

			panel.classList.remove( 'is-active' );
			panel.hidden = true;

		} );

		tab.classList.add( 'is-active' );
		tab.setAttribute( 'aria-selected', 'true' );

		const activeTabIndex = tab.dataset.index;
		const targetPanel = tabsNav.nextElementSibling?.querySelector( `[data-index="panel-${activeTabIndex}"]` );

		if ( targetPanel ) {

			targetPanel.classList.add( 'is-active' );
			targetPanel.hidden = false;

		}

	} );

} );
